// Decorative SVG: Base Camp -> Trail 1 -> Trail 2 -> Trail 3 -> Summit with gold progress indicator
const stops = [
  { label: "Base Camp", x: 50, y: 380 },
  { label: "Trail 1", x: 170, y: 310 },
  { label: "Trail 2", x: 280, y: 240 },
  { label: "Trail 3", x: 400, y: 170 },
  { label: "Summit", x: 520, y: 80 },
];

export const MountainTrailHero = ({ progressIndex = 2 }) => {
  // Build polyline through stops
  const pathD = `M ${stops[0].x} ${stops[0].y} ` +
    stops.slice(1).map((s, i) => {
      const prev = stops[i];
      const mx = (prev.x + s.x) / 2;
      const my = (prev.y + s.y) / 2 - 18;
      return `Q ${mx} ${my} ${s.x} ${s.y}`;
    }).join(" ");

  return (
    <div className="relative w-full h-full bg-topo-dark rounded-2xl overflow-hidden" data-testid="hero-mountain-svg">
      <svg viewBox="0 0 600 460" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        {/* mountain silhouettes */}
        <defs>
          <linearGradient id="peak" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#2E5A85" />
            <stop offset="1" stopColor="#1B3A5C" />
          </linearGradient>
          <linearGradient id="snow" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#EAF1F7" />
            <stop offset="1" stopColor="#A7C0D2" stopOpacity="0.0" />
          </linearGradient>
        </defs>

        {/* back range */}
        <polygon points="0,420 120,260 220,330 340,200 460,290 600,160 600,460 0,460" fill="#2A4D72" opacity="0.55" />
        {/* front range */}
        <polygon points="0,460 80,330 200,400 340,250 460,360 600,230 600,460" fill="url(#peak)" />
        {/* snow caps */}
        <polygon points="320,260 340,250 360,265 348,272" fill="#EAF1F7" />
        <polygon points="440,295 460,290 480,305 470,312" fill="#EAF1F7" />
        <polygon points="580,235 600,228 600,250" fill="#EAF1F7" />

        {/* trail dotted path */}
        <path d={pathD} fill="none" stroke="#5B8FA8" strokeWidth="3" strokeDasharray="2 8" strokeLinecap="round" />
        {/* completed portion (gold) */}
        <path
          d={pathD}
          fill="none"
          stroke="#D4A843"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="1000"
          strokeDashoffset={1000 - (progressIndex / (stops.length - 1)) * 1000}
          style={{ transition: "stroke-dashoffset 800ms ease" }}
        />

        {/* stops */}
        {stops.map((s, i) => {
          const reached = i <= progressIndex;
          return (
            <g key={s.label}>
              <circle cx={s.x} cy={s.y} r={reached ? 11 : 8} fill={reached ? "#D4A843" : "#1B3A5C"} stroke="#F4F1E8" strokeWidth="3" />
              {i === progressIndex && (
                <circle cx={s.x} cy={s.y} r="18" fill="none" stroke="#D4A843" strokeWidth="2" opacity="0.6">
                  <animate attributeName="r" values="14;22;14" dur="2.4s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.7;0;0.7" dur="2.4s" repeatCount="indefinite" />
                </circle>
              )}
              <text
                x={s.x}
                y={s.y - 20}
                textAnchor="middle"
                fontFamily="Outfit, sans-serif"
                fontWeight="700"
                fontSize="13"
                fill={reached ? "#F4F1E8" : "#A7C0D2"}
              >
                {s.label}
              </text>
            </g>
          );
        })}

        {/* compass rose corner */}
        <g transform="translate(540,400)" opacity="0.7">
          <circle r="28" fill="none" stroke="#D4A843" strokeWidth="1.5" />
          <polygon points="0,-26 4,0 0,26 -4,0" fill="#D4A843" />
          <polygon points="-26,0 0,4 26,0 0,-4" fill="#5B8FA8" />
          <text x="0" y="3" textAnchor="middle" fontFamily="Outfit, sans-serif" fontWeight="900" fontSize="14" fill="#F4F1E8">M</text>
        </g>
      </svg>
    </div>
  );
};

export default MountainTrailHero;
